<template>
  <div class="index" @click="hidedialog">
    <headerview></headerview>
    <div class="content">
      <div class="content-left">
        <el-menu
          :default-active="defaultAction"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
        >
          <el-menu-item index="/index/new" @click="linkto('/index/new')">
            <i class="el-icon-document-add"></i>
            <span style="font-size: 16px" slot="title">新建</span>
          </el-menu-item>
          <el-menu-item
            index="/index/history"
            @click="linkto('/index/history')"
          >
            <i class="el-icon-document"></i>
            <span style="font-size: 16px" slot="title">发送记录</span>
          </el-menu-item>
          <el-menu-item
            index="/index/analysis"
            @click="linkto('/index/analysis')"
          >
            <i class="el-icon-data-line"></i>
            <span style="font-size: 16px" slot="title">统计分析</span>
          </el-menu-item>
          <el-menu-item
            index="/index/provid"
            @click="linkto('/index/provid')"
            style="positon: relative"
          >
            <!-- <img src="@/assets/activeImg.png" alt="" class="activeImg" /> -->
            <i class="el-icon-money"></i>
            <span style="font-size: 16px" slot="title">我的套餐</span>
          </el-menu-item>
          <el-menu-item index="/index/system" @click="linkto('/index/system')">
            <i class="el-icon-coin"></i>
            <span style="font-size: 16px" slot="title">系统集成</span>
          </el-menu-item>
          <el-menu-item index="/index/setup" @click="linkto('/index/setup')">
            <i class="el-icon-setting"></i>
            <span style="font-size: 16px" slot="title">设置</span>
          </el-menu-item>
        </el-menu>
        <img src="@/assets/gztleft.png" class="bottomimg" alt="" />
      </div>
      <div class="content-right">
        <router-view style=""></router-view>
      </div>
    </div>
    <tip :activeShow="activeShow"></tip>
  </div>
</template>

<script>
// @ is an alias to /src
import { Upload, Button } from "iview";
import Cookie from "js-cookie";
import headerview from "@/components/header.vue";
import tip from "@/components/tip.vue";

export default {
  name: "index",
  components: {
    Upload,
    Button,
    headerview,
    tip,
  },
  data() {
    return {
      menuName: "",
      siteUrl: this.$http.defaults.url_base, //https://payroll.joyousoa.com/#/index/new
      defaultAction: "",
      activeShow: false,
    };
  },
  methods: {
    hidedialog(e) {
      if (e.target.className != "tipList") {
        this.$store.state.showTip = false;
      }
      // vipitem item-buys
      // console.log(
      //   e.target.className != 'vipitem' || e.target.className != 'item-buys'
      // )
      if (
        e.target.className != "vipitem" &&
        e.target.className != "item-buys" &&
        e.target.className != ""
      ) {
        this.$store.state.vipshowTip = false;
      }
    },
    // toindex () {
    //   this.$router.push('index')
    // },
    // tootherindex () {
    //   let routeUrl = this.$router.resolve({
    //     path: '/enterpriseIndex'// 这里的路径就可以正常的写，不需要添加_blank: true
    //   })
    //   window.open(routeUrl.href, '_blank')
    //   // this.$router.push('')
    // },
    linkto(path) {
      console.log(path);
      this.$router.push(path);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSuccess(response) {},
    onerror() {
      this.$message({
        type: "info",
        message: "上传失败",
      });
    },
    logout() {
      window.sessionStorage.removeItem("token");
      this.$router.replace("/login");
      window.location.reload();
    },
  },
  created() {
    if (this.$route.path == "/index/provid/purchaserecord") {
      this.defaultAction = "/index/provid";
    } else {
      this.defaultAction = this.$route.path;
    }
    // this.menuName = JSON.parse(Cookie.get('userInfo')).abbreviation
    //
  },
  computed: {
    nameChange() {
      return this.$store.state.modifyName;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.$route.path == "/index/provid") {
          this.activeShow = true;
        } else {
          this.activeShow = false;
        }
        if (this.$route.path == "/index/provid/purchaserecord") {
          this.defaultAction = "/index/provid";
        } else {
          this.defaultAction = this.$route.path;
        }
      },
    },
    nameChange(val) {
      console.log(val);
      if (val) {
        // this.menuName = JSON.parse(Cookie.get('userInfo')).abbreviation
        //
        this.$store.commit("modifyName", false);
      }
    },
  },
};
</script>

<style lang="less" scoped>
// .header-wrap {
//   border-bottom: 1px solid rgba(204, 204, 204, 0.3);
//   header {
//     width: 95%;
//     height: 79px;
//     margin: 0 auto;
//     display: flex;
//     justify-content: space-between;
//     .header-left {
//       display: flex;
//       align-items: center;
//       justify-content: left;
//     }
//     .header-right {
//       display: flex;
//       align-items: center;
//       justify-content: left;
//       .otherapp {
//         width: 120px;
//         height: 40px;
//         background: #3bc492;
//         box-shadow: 0px 6px 58px 0px rgba(196, 203, 214, 0.1);
//         border-radius: 4px;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         cursor: pointer;
//         img {
//           height: 14px;
//         }
//         span {
//           font-size: 16px;
//           font-family: PingFangSC-Medium, PingFang SC;
//           font-weight: 500;
//           color: #ffffff;
//           line-height: 24px;
//           margin-left: 8px;
//         }
//       }
//       .company-name {
//         font-size: 16px;
//         font-family: PingFangSC-Regular, PingFang SC;
//         font-weight: 400;
//         color: #0a1629;
//         line-height: 24px;
//       }
//       .line {
//         width: 1px;
//         height: 44px;
//         opacity: 0.1;
//         border: 1px solid #000000;
//         margin: 0 15px;
//       }
//       .el-dropdown-link {
//         font-size: 16px;
//         font-family: PingFangSC-Regular, PingFang SC;
//         font-weight: 400;
//         color: #0a1629;
//         line-height: 24px;
//       }
//       .msg {
//         display: flex;
//         align-items: center;
//         justify-content: left;
//         cursor: pointer;
//         span {
//           font-size: 16px;
//           font-family: PingFangSC-Regular, PingFang SC;
//           font-weight: 400;
//           color: #0a1629;
//           line-height: 24px;
//           margin-left: 9px;
//         }
//         img {
//           height: 17px;
//         }
//       }
//     }
//   }
// }
.content {
  display: flex;

  .content-left {
    // min-width: 12%;
    width: 200px;
    height: calc(100vh - 80px);
    position: relative;

    /deep/.is-active {
      background: #3bc492;
      color: #fff;
      border-left: 5px solid rgba(255, 255, 255, 0.715);
    }

    .bottomimg {
      position: absolute;
      bottom: 20px;
      left: 15px;
      width: 85%;
      text-align: center;
    }
  }

  .content-right {
    overflow: auto;
    background: #f7f7f8;
    flex: 1;
    height: calc(100vh - 61px);
  }
}

.el-icon-questio {
  font-size: 22px;
  // background-color: #444;
  width: 190px;
  height: 50px;
  font-size: 16px;
  color: #3bc492;
  font-weight: 600;

  .phone-box {
    color: #3bc492;
    font-size: 23px;
  }
}

.hover-i {
  float: right;
  color: rgba(131, 143, 153, 1);
  font-size: 16px;
  cursor: pointer;
  position: relative;

  &:hover {
    &:after {
      position: absolute;
      bottom: -30px;
      right: 0px;
      width: 300px;
      height: 30px;
      line-height: 30px;
      border-radius: 10px;
      font-size: 12px;
      color: rgba(44, 45, 58, 1);
      text-align: center;
      background: rgba(243, 245, 247, 1);
      border-radius: 4px;
      content: "如有疑问，请致电客服热线：18971608045";
    }
  }
}

.active {
  color: rebeccapurple;
}

.el-dropdown-link {
  cursor: pointer;
}

.index {
  .dialog-footer {
    padding-bottom: 80px;
  }

  .btn-container {
    text-align: center;
  }
}

.router-link {
  display: inline-block;
  margin-left: 40px;

  > a {
    display: inline-block;
    height: 100%;
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(131, 143, 153, 1);

    &.active {
      color: #152436;
      border-bottom: 2px solid #3bc492;
    }
  }
}

/deep/.el-button--success {
  /*font-weight: 600;*/
  font-size: 17px;
  font-family: PingFangSC-Semibold;
}
/deep/ .el-menu {
  border-right: 0px;
}
.activeImg {
  width: auto !important;
  height: 56px;
  position: absolute !important;
  right: -5px;
  top: -5px;
}
</style>
